import { VALIDATE_WITH_MESSAGE } from "@moneyforward/mfx_biz_react_components";

export const usernameValidation = {
  required: (v) => VALIDATE_WITH_MESSAGE.required(v),
  minLength: (v) => VALIDATE_WITH_MESSAGE.minLength(v, 1),
  maxLength: (v) => VALIDATE_WITH_MESSAGE.maxLength(v, 128),
  pattern: (v) => XID_VALIDATE_WITH_MESSAGE.username(v),
};

export const loginIDValidation = {
  required: (v) => VALIDATE_WITH_MESSAGE.required(v),
  minLength: (v) => VALIDATE_WITH_MESSAGE.minLength(v, 1),
  maxLength: (v) => VALIDATE_WITH_MESSAGE.maxLength(v, 128),
};

export const passwordValidation = {
  required: (v) => VALIDATE_WITH_MESSAGE.required(v),
  minLength: (v) => VALIDATE_WITH_MESSAGE.minLength(v, 8),
  maxLength: (v) => VALIDATE_WITH_MESSAGE.maxLength(v, 256),
  pattern: (v) => XID_VALIDATE_WITH_MESSAGE.password(v),
};

export const emailValidation = {
  required: (v) => VALIDATE_WITH_MESSAGE.required(v),
  email: (v) => VALIDATE_WITH_MESSAGE.email(v),
};

export const termsValidation = {
  required: (v) => VALIDATE_WITH_MESSAGE.required(v),
};

export const companyNameValidation = {
  required: (v) => VALIDATE_WITH_MESSAGE.required(v),
  maxLength: (v) => VALIDATE_WITH_MESSAGE.maxLength(v, 255),
};

export const KanaCompanyNameValidation = {
  kana: (v) => !v || VALIDATE_WITH_MESSAGE.kana(v),
  maxLength: (v) => VALIDATE_WITH_MESSAGE.maxLength(v, 255),
};

export const nameValidation = {
  maxLength: (v) => VALIDATE_WITH_MESSAGE.maxLength(v, 32),
};

export const requiredNameValidation = {
  required: (v) => VALIDATE_WITH_MESSAGE.required(v),
  maxLength: (v) => VALIDATE_WITH_MESSAGE.maxLength(v, 32),
};

export const kanaNameValidation = {
  kana: (v) => VALIDATE_WITH_MESSAGE.kana(v),
  maxLength: (v) => VALIDATE_WITH_MESSAGE.maxLength(v, 32),
};

export const requiredKanaNameValidation = {
  required: (v) => VALIDATE_WITH_MESSAGE.required(v),
  kana: (v) => VALIDATE_WITH_MESSAGE.kana(v),
  maxLength: (v) => VALIDATE_WITH_MESSAGE.maxLength(v, 32),
};

export const middleNameValidation = {
  maxLength: (v) => VALIDATE_WITH_MESSAGE.maxLength(v, 32),
};

export const kanaMiddleNameValidation = {
  kana: (v) => !v || VALIDATE_WITH_MESSAGE.kana(v),
  maxLength: (v) => VALIDATE_WITH_MESSAGE.maxLength(v, 32),
};

export const requiredValidation = {
  required: (v) => VALIDATE_WITH_MESSAGE.required(v),
};

export const corporateNumberValidation = {
  pattern: (v) => XID_VALIDATE_WITH_MESSAGE.corporateNumber(v),
};

export const qualifiedInvoiceIssuerRegistrationNumberValidation = (
  checked: boolean
) => ({
  required: (v) => !checked || (checked && VALIDATE_WITH_MESSAGE.required(v)),
  pattern: (v) =>
    !checked ||
    XID_VALIDATE_WITH_MESSAGE.qualifiedInvoiceIssuerRegistrationNumber(v),
});

export const businessContentValidation = {
  maxLength: (v) => VALIDATE_WITH_MESSAGE.maxLength(v, 255),
};

export const dateValidation = {
  pattern: (v) => XID_VALIDATE_WITH_MESSAGE.date(v),
};

export const capitalValidation = {
  maxLength: (v) => VALIDATE_WITH_MESSAGE.maxDigit(v, 6, 4),
};

export const phoneNumberValidation = {
  required: (v) => VALIDATE_WITH_MESSAGE.required(v),
  pattern: (v) => XID_VALIDATE_WITH_MESSAGE.phoneNumber(v),
};

export const siteUrlValidation = {
  url: (v) => !v || VALIDATE_WITH_MESSAGE.url(v),
  maxLength: (v) => VALIDATE_WITH_MESSAGE.maxLength(v, 1024),
};

export const postalCodeValidation = (length: number) => ({
  pattern: (v) => XID_VALIDATE_WITH_MESSAGE.postalNumber(v, length),
});

export const municipalityValidation = {
  required: (v) => VALIDATE_WITH_MESSAGE.required(v),
  maxLength: (v) => VALIDATE_WITH_MESSAGE.maxLength(v, 64),
};

export const blockBuildingNameValidation = {
  required: (v) => VALIDATE_WITH_MESSAGE.required(v),
  maxLength: (v) => VALIDATE_WITH_MESSAGE.maxLength(v, 255),
};

export const representativeNameValidation = {
  required: (v) => VALIDATE_WITH_MESSAGE.required(v),
  maxLength: (v) => VALIDATE_WITH_MESSAGE.maxLength(v, 255),
};

export const representativeEmailAddressValidation = {
  email: (v) => !v || VALIDATE_WITH_MESSAGE.email(v),
  maxLength: (v) => VALIDATE_WITH_MESSAGE.maxLength(v, 255),
};

export const insuranceAgencyCodeValidation = {
  required: (v) => VALIDATE_WITH_MESSAGE.required(v),
  maxLength: (v) => VALIDATE_WITH_MESSAGE.maxLength(v, 6),
  alphaNum: (v) => VALIDATE_WITH_MESSAGE.alphaNum(v),
};

export const insuranceAgencyNameValidation = {
  required: (v) => VALIDATE_WITH_MESSAGE.required(v),
  maxLength: (v) => VALIDATE_WITH_MESSAGE.maxLength(v, 50),
};

export const mainUserNameValidation = {
  required: (v) => VALIDATE_WITH_MESSAGE.required(v),
  maxLength: (v) => VALIDATE_WITH_MESSAGE.maxLength(v, 255),
};

export const XID_VALIDATE_ERROR_MESSAGES = {
  username: () => "半角英数字 - _ . が利用できます",
  password: () => "半角英数字または半角記号が利用できます",
  corporateNumber: () => "13桁の数字で入力してください。",
  qualifiedInvoiceIssuerRegistrationNumber: () =>
    "13桁の数字で入力してください。",
  date: () => "yyyy/MM/ddの形式で入力してください。",
  phoneNumber: () => "有効な電話番号を入力してください。",
  postalNumber: (length: number) => `${length}桁の数字で入力してください。`,
};

const username = (value: any) => {
  if (typeof value !== "string") return true;
  return /^[a-zA-z0-9_.-]+$/.test(value);
};

const password = (value: any) => {
  if (typeof value !== "string") return true;
  return /^[!-~]+$/.test(value);
};

const corporateNumber = (value: any) => {
  if (typeof value !== "string") return true;
  return /^([0-9]{13})?$/.test(value);
};

const qualifiedInvoiceIssuerRegistrationNumber = (value: any) => {
  if (typeof value !== "string") return true;
  return /^([0-9]{13})?$/.test(value);
};

export const validateDate = (value: any) => {
  if (typeof value !== "string" || value === "") return true;

  const regex = /^\d{4}\/\d{2}\/\d{2}$/;
  if (!regex.test(value)) return false;

  // just checking that new Date() doesn't throw an error is not enough as
  // new date will handle out of range dates such as 2024/02/31 by adjusting
  // the date to 2024/03/02
  const date = new Date(value);

  const [year, month, day] = value.split("/").map(Number);

  return (
    date.getFullYear() === year &&
    date.getMonth() + 1 === month && // getMonth() returns 0-based month
    date.getDate() === day
  );
};

const phoneNumber = (value: any) => {
  if (typeof value !== "string") return true;
  return /^([0-9]{10,11})$/.test(value);
};

const postalNumber = (value: any, length: number) => {
  if (typeof value !== "string") return true;
  const reg = new RegExp("^([0-9]{" + length + "})$");
  return reg.test(value);
};

export const XID_VALIDATOR = {
  username,
  password,
  corporateNumber,
  qualifiedInvoiceIssuerRegistrationNumber,
  date: validateDate,
  phoneNumber,
  postalNumber,
};

export const XID_VALIDATE_WITH_MESSAGE = {
  username: (value: any) =>
    XID_VALIDATOR.username(value) || XID_VALIDATE_ERROR_MESSAGES.username(),
  password: (value: any) =>
    XID_VALIDATOR.password(value) || XID_VALIDATE_ERROR_MESSAGES.password(),
  corporateNumber: (value: any) =>
    XID_VALIDATOR.corporateNumber(value) ||
    XID_VALIDATE_ERROR_MESSAGES.corporateNumber(),
  qualifiedInvoiceIssuerRegistrationNumber: (value: any) =>
    XID_VALIDATOR.qualifiedInvoiceIssuerRegistrationNumber(value) ||
    XID_VALIDATE_ERROR_MESSAGES.qualifiedInvoiceIssuerRegistrationNumber(),
  date: (value: any) =>
    XID_VALIDATOR.date(value) || XID_VALIDATE_ERROR_MESSAGES.date(),
  phoneNumber: (value: any) =>
    XID_VALIDATOR.phoneNumber(value) ||
    XID_VALIDATE_ERROR_MESSAGES.phoneNumber(),
  postalNumber: (value: any, length: number) =>
    XID_VALIDATOR.postalNumber(value, length) ||
    XID_VALIDATE_ERROR_MESSAGES.postalNumber(length),
};
